// extracted by mini-css-extract-plugin
export default {"root":"JU9yiE","checkbox":"duu0fM","checkboxError":"z38ZLR"};